import { combineReducers } from 'redux';
import { cart } from './Reducers/Cart.reducer';
import { quickSearch } from './Reducers/QuickSearch.reducer';
import { navigation } from './Reducers/Navigation.reducer';
import { configurator } from './Reducers/Configurator.reducer';
import { facetedSearch } from './Reducers/FacetedSearch.reducer';
import { myPage } from './Reducers/MyPage.reducer';
import { checkout } from './Reducers/Checkout.reducer';
import { lightboxImages } from './Reducers/LightboxImages.reducer';
import { notification } from './Reducers/Notification.reducer';
import { favouritesData } from './Reducers/Favourites.reducer';
import { articleStock } from './Reducers/StockConfig.reducer';
import { googleMap } from './Reducers/GoogleMap.reducer';
import { CustomizedMessage } from './Reducers/CustomizedMessage.reducer';
import { resetPasswordPopup } from './Reducers/ResetPasswordPopup.reducer';
import { organizationList } from './Reducers/OrganizationList.reducer';
import { savedCart } from './Reducers/savedCart.reducer';
import { orderHistory } from './Reducers/OrderHistory.reducer';

const app = combineReducers({
  cart,
  checkout,
  quickSearch,
  navigation,
  myPage,
  facetedSearch,
  lightboxImages,
  notification,
  favouritesData,
  configurator,
  articleStock,
  googleMap,
  CustomizedMessage,
  resetPasswordPopup,
  organizationList,
  savedCart,
  orderHistory
});

export default app;
